import { array, object, string, z, number, boolean } from "zod";
import {
  AddressInfoSchema,
  ContactDetailsSchema,
  investorInvestmentAccountSchema,
  NomineeDetailsSchema,
  OtherInfoSchema,
  PersonalInfoSchema,
} from "creso-core/zod";

export const NomineeFormSchema = NomineeDetailsSchema.and(
  z.object({
    nominee_id: string().or(number()).optional(),
  })
);

export const AccountCenterFormSchema = z.object({
  profile: PersonalInfoSchema,
  address: AddressInfoSchema,
  bank: array(
    object({
      account_number: string(),
      type: string().optional(),
      ifsc_code: string().optional(),
      primary_account_holder_name: string().optional(),
      bank_account_id: string().or(number()).optional(),
      is_default: boolean().optional(),
    })
  ),
  nominees: array(NomineeFormSchema),
  contact: ContactDetailsSchema,
  account: investorInvestmentAccountSchema.optional(),
  other: OtherInfoSchema,
});

export type AccountCenterFormValues = z.infer<typeof AccountCenterFormSchema>;

export type SectionName =
  | "profile"
  | "address"
  | "bank"
  | "nominees"
  | "contact"
  | "account"
  | "other";
